// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { ProbabilityNode_abstract } from './../abstract/SagaBase/ProbabilityNode_abstract';
export class ProbabilityNode extends ProbabilityNode_abstract {}
